import './App.css';
import Header from "./Components/Header/Header"
import EnquiryForm from './Pages/Enquiry/Enquiry';
import Footer from '.././src/Components/Footer/Footer'
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './Pages/Home/Home';
import About from "./Pages/About/About";
import Curriculum from './Pages/Curriculum/Curriculum' ;
import Gallery from "./Pages/Gallery/Gallery"
import ScrollToTop from "./Components/ScrollToTop";
import Careers from './Pages/Careers/Careers';

function App() {
  return (
    <Router>
    <div className="App">
      <ScrollToTop/>
    <Header/>
    <div className="content">  
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About/>} />

              <Route path="/enquiry" element={<EnquiryForm/>} />
              <Route path="/curriculum" element={<Curriculum/>} />
              <Route path="/gallery" element={<Gallery/>} />
              <Route path="/careers" element={<Careers/>} />

        </Routes>
      </div>


      <Footer/>
    </div>
    </Router>
  );
}

export default App;
